<script>
export default {
  props: {
    module: {
      type: Object,
    },
  },
};
</script>
<template>
  <Card class="p-t-c-lfi">
    <CardTitle>Фильтры</CardTitle>
    <FBody
      :module="module"
    >
      <RowSpan>
        <ColSpan
          span="6"
        >
          <FItem
            :module="module.getItem('priceFrom')"
          />
        </ColSpan>
        <ColSpan
          span="6"
        >
          <FItem
            :module="module.getItem('priceTo')"
          />
        </ColSpan>
      </RowSpan>
      <RowSpan>
        <ColSpan>
          <FItem
            :module="module.getItem('name')"
          />
        </ColSpan>
      </RowSpan>
    </FBody>
  </Card>
</template>
<style lang="scss">
.col-span{
  margin-left: 0px!important;
}
</style>

